<template>
  <div>
    <font-awesome-icon icon="bed" size="4x" />
    <h1>No services</h1>
  </div>
</template>

<script>
export default {
  name: "Empty"
};
</script>

<style scoped>
div {
  font-size: 4rem;
  text-align: center;
}
</style>
